export const formatAmount = (amount) => {
  const num = Number(amount);
  if (isNaN(num)) {
    return '0';
  }
  if (num >= 1000000000) {
    return `${(num / 1000000000).toFixed(2)}B`;
  } else if (num >= 1000000) {
    return `${(num / 1000000).toFixed(2)}M`;
  } else if (num >= 1000) {
    return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return Number.isInteger(num) ? num.toString() : parseFloat(num.toFixed(4)).toString();
  }
};